import useMessage from '../Hooks/useMessage'

import axios from 'axios'
export const mainUrl = process.env.REACT_APP_URL // "http://localhost:3000/";
export const baseURL = process.env.REACT_APP_API_URL // Коллеги нужно использовать это! Смотрите пример .env.local.example

export const apiURL = '/api/v1/'
// export const baseURL = "https://api.bolashak.crocos.kz/api/v1/";
// export const baseURL = "https://api-konkurs.bolashak.gov.kz"; // Это уже старый вариант!
// export const baseURL = "https://api-konkurs.bolashak.gov.kz"; // "http://localhost:8000"; Если env не настроен

const axiosInstance = axios.create({
	baseURL: `${baseURL}${apiURL}`,
	headers: {
		'Content-type': 'application/json',
		'Access-Control-Allow-Origin': '*',
		'X-locale': localStorage.getItem('i18nextLng'),
	},
})

axiosInstance.interceptors.response.use(
	function (response) {
		return response
	},
	function (error) {
		if (!error?.config?.url?.includes('system-logs')) {
			const status = error?.response?.status
			import('./SystemLogger').then(({ logEvent }) => {
				logEvent('api', 'request-error', {
					level: status === 401 || status === 422 ? 'warning' : 'error',
					message: error.message,
					data: {
						url: error?.config?.url,
						method: error?.config?.method,
						status,
					},
				})
			})
		}
		return Promise.reject(error)
	}
)

export default axiosInstance
